import { useState, useCallback, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import { getForwardCommunicatorState } from 'composer-data/email/public/selectors';
import { getGenericChannelId, getEmailMetadataAttachment } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
// TODO: move to composer-ui

import { EMAIL_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
import { getIsRequiredMetaDataInfoMissing } from '../operators/getIsRequiredMetaDataInfoMissing';
import AbsoluteMetadataEditor from './AbsoluteMetadataEditor';
import DynamicMetadataEditor from './DynamicMetadataEditor';
import MetadataEditorSkeleton from './MetadataEditorSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const _MetadataBar = ({
  inboxId,
  reply,
  handleChange,
  isComposer,
  isMetadataEditorAbsolute,
  useWhatsAppCompose,
  defaultSendFromEnabled,
  handleFirstClick
}, ref) => {
  const [expanded, setExpanded] = useState(false);
  const [senderSubjectExpanded, setSenderSubjectExpanded] = useState(isComposer // for new emails show sender and subject by default
  );
  const {
    replyAll
  } = useSelector(getForwardCommunicatorState);
  useEffect(() => {
    setExpanded(false);
  }, [replyAll]);
  const DynamicMetadataComponent = isMetadataEditorAbsolute ? AbsoluteMetadataEditor : DynamicMetadataEditor;
  const handleExpand = useCallback(() => {
    setExpanded(true);
  }, [setExpanded]);
  const toggleSenderSubjectExpand = useCallback(() => {
    setSenderSubjectExpanded(!senderSubjectExpanded);
  }, [setSenderSubjectExpanded, senderSubjectExpanded]);
  const isRequiredMetaDataInfoMissing = getIsRequiredMetaDataInfoMissing(reply);
  useImperativeHandle(ref, () => ({
    expanded,
    onShrink: () => {
      setExpanded(false);
      const keepSenderSubjectExpanded = isRequiredMetaDataInfoMissing || isComposer;
      setSenderSubjectExpanded(keepSenderSubjectExpanded);
    }
  }), [expanded, isRequiredMetaDataInfoMissing, isComposer]);
  const commonMessage = getCommonMessage(reply);
  const isEmailMissingMetadata = getGenericChannelId(commonMessage) === EMAIL_GENERIC_CHANNEL_ID && !getEmailMetadataAttachment(commonMessage);
  const isMetadataLoading = !commonMessage || isEmailMissingMetadata;
  return isMetadataLoading ? /*#__PURE__*/_jsx(MetadataEditorSkeleton, {}) : /*#__PURE__*/_jsx(DynamicMetadataComponent, {
    expanded: expanded,
    inboxId: inboxId,
    reply: reply,
    onChange: handleChange,
    onExpand: handleExpand,
    isComposer: isComposer,
    senderSubjectExpanded: senderSubjectExpanded,
    toggleSenderSubjectExpand: toggleSenderSubjectExpand,
    useWhatsAppCompose: useWhatsAppCompose,
    defaultSendFromEnabled: defaultSendFromEnabled,
    handleFirstClick: handleFirstClick
  });
};
_MetadataBar.displayName = 'MetadataBar';
export const MetadataBar = /*#__PURE__*/forwardRef(_MetadataBar);